import {Canvas} from "./Canvas";
import {drawTextBlock} from "./CanvasUtils.ts";

export class ProcessCanvas extends Canvas {
	/**
	 * @param {ProcessEditor} editor
	 */
	constructor(editor) {
		super(editor);
	}

	get model() {
		return this.editor.model;
	}

	/**
	 * @param {CanvasRenderingContext2D} ctx
	 */
	drawModel(ctx, currentTool) {
		ctx.save();
		ctx.font = "normal 10px \"Helvetica Neue\"";

		const pixelWidth = (1/this.editor.pixel)/this.zoom;

		for (let ed of this.editor.laneEditors) {
			ed.draw(ctx);
			if (ed.selected) ed.drawHandlers(ctx, pixelWidth);
		}
		for (let ed of this.editor.edgeEditors) {
			ed.draw(ctx);
			if (ed.selected) ed.drawHandlers(ctx, pixelWidth);
		}
		for (let ed of this.editor.nodeEditors) {
			ed.draw(ctx);
			if (ed.selected) ed.drawHandlers(ctx, pixelWidth);
		}
		ctx.restore();
	}

	drawBeforeModel(ctx, currentTool) {
		const pixelWidth = (1/this.editor.pixel)/this.zoom;
		currentTool.drawBeforeModel(ctx, pixelWidth);
	}

	drawAfterModel(ctx, currentTool) {
		const pixelWidth = (1/this.editor.pixel)/this.zoom;
		currentTool.drawAfterModel(ctx, pixelWidth);
	}

	unselectAll() {
		for (let ed of this.editor.edgeEditors) {
			ed.selected = false;
			ed.hovered = false;
		}
		for (let ed of this.editor.nodeEditors) {
			ed.selected = false;
			ed.hovered = false;
		}
	}

	getManipulables() {
		const neds = this.editor.nodeEditors;
		const eeds = this.editor.edgeEditors;
		const sleds = this.editor.laneEditors;
		return sleds.concat(eeds).concat(neds);
	}

	getConnectFromManipulables() {
		const mp = [];
		for (let ed of this.editor.nodeEditors) {
			if (ed.canConnectFrom()) mp.push(ed);
		}
		return mp;
	}

	getConnectToManipulables(fromEditor) {
		const mp = [];
		for (let ed of this.editor.nodeEditors) {
			if (ed.canConnectTo(fromEditor)) mp.push(ed);
		}
		return mp;
	}
}